import type { OnboardingNavItem } from './OnboardingNav';
import { STEPS, STEP_ICONS } from './onboardingSteps';

/**
 * Create mode's step list (`twin-details-page-create`, R2.5; frame 01): the whole journey from the
 * start — every step in `STEPS` order, then Launch — with Twin details open and every other step
 * locked until the twin exists. No `lockedReason`, so each takes the list's own *Create the twin
 * first*.
 *
 * Its own small list rather than a flag on the wizard's `stepNav`: create mode has no twin, so none
 * of what `stepNav` reads (ticks, scores, the composites gate) exists, and the full wizard's list
 * stays untouched. Labels come from `STEPS` and markers from `STEP_ICONS`, as the wizard's do.
 */
export const createModeNavItems = (launchLabel: string): OnboardingNavItem[] => [
  ...STEPS.map(step => ({
    id: step.id,
    label: step.title,
    ...(STEP_ICONS[step.id] && { icon: STEP_ICONS[step.id] }),
    ...(step.id !== 'twinDetails' && { locked: true }),
  })),
  { id: 'launch', label: launchLabel, isLaunch: true, icon: STEP_ICONS.launch, locked: true },
];
